<app-tablepage-base [loading]="loading">
  <p-table [value]="works"
           [paginator]="true" [rows]="25"
           [scrollable]="true" scrollHeight="flex"
           [globalFilterFields]="['name', 'organization']"
           stripedRows
           #dt
           class="flex h-full min-h-0 flex-col">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">{{ 'titles.listWorkers' | translate }}</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'smartGlobalFilter')" placeholder="{{ 'search' | translate }}..." />
          </div>
          <p-button variant="outlined" icon="pi pi-clock" [label]="'newCron' | translate" (click)="onShowDialog(newWork)" />
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th>{{ 'name' | translate }}</th>
        <th>{{ 'organization' | translate }}</th>
        <th><div class="flex items-center justify-center">{{ 'departments' | translate }}</div></th>
        <th><div class="flex items-center justify-center">{{ 'execution' | translate }}</div></th>
        <th><div class="flex items-center justify-center">{{ 'last' | translate }} {{ 'execution' | translate }}</div></th>
        <th><div class="flex items-center justify-center">{{ 'next' | translate }} {{ 'execution' | translate }}</div></th>
        <th style="width:10%"><div class="flex items-center justify-center">{{ 'status' | translate }}</div></th>
        <th style="width:10%"></th>
      </tr>
    </ng-template>
    <ng-template #body let-work>
      <tr>
        <td>{{ work.name | translate }}</td>
        <td>{{ work.organization }}</td>
        <td>
          <div *ngFor="let d of work.departments" class="flex items-center justify-center">{{ d }}</div>
        </td>
        <td><div class="flex items-center justify-center">{{ getFrequencyString(work) }}</div></td>
        <td><div class="flex items-center justify-center">{{ work.last | statusDate }}</div></td>
        <td><div class="flex items-center justify-center">{{ work.next | statusDate }}</div></td>
        <td>
          <div class="flex items-center justify-center">
            <i class="pi"
               [ngClass]="work.isEnabled ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-400'"
               style="font-size: 1.4rem;"></i>
          </div>
        </td>
        <td>
          <p-button icon="pi pi-user-edit" (click)="onShowDialog(work)" />
        </td>
      </tr>
    </ng-template>
  </p-table>

  <app-work-dialog [isNew]="isNew"
                   [messageService]="messageService"
                   [(visible)]="showDialog"
                   [work]="selectedWork"
                   (saved)="onWorkSaved($event)">
  </app-work-dialog>
</app-tablepage-base>
